<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['patient_payments']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
                <div class="m-0 d-flex justify-content-md-center">
                  <div class="form-group">
                  <label>Date From</label>
                  <input v-model="datefrom" type="date" class="form-control" />
                  </div>
                  <div class="form-group ms-2">
                  <label>Date To</label>
                  <input v-model="dateto" type="date" class="form-control" />
                  </div>
                  <span><br><b-button @click="FilterData" class="mt-2 mx-2" variant="primary"><i class="mdi mdi-filter"></i> Filter</b-button></span>
                </div>
                <div class="clearfix"></div>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                      <label class="d-inline-flex align-items-center">
                        Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <b-table
                    :items="Items"
                    :fields="Fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="Filtered"
                    :busy="IsBusy"
                  >
                  <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(patient_id)="data">
                    {{ data.item.patient.patient_id }}
                  </template>
                  <template #cell(name)="data">
                    <b>{{ data.item.patient.name }}</b><br>
                    <small>0{{ data.item.patient.telephone }}</small>
                  </template>
                  <template #cell(prescription)="data">
                    {{ commas(data.item.prescriptions) }}
                  </template>
                  <template #cell(consumables)="data">
                    {{ commas(data.item.consumables) }}
                  </template>
                  <template #cell(paid)="data">
                    {{ commas(data.item.paid) }}
                  </template>
                 
                  <template #cell(total_amount)="data">
                    {{ commas(data.item.total_amount) }}
                  </template>
                  <template #cell(discount)="data">
                    {{ commas(data.item.discount) }}
                  </template>
                  <!-- <template #cell(charge)="data">
                    {{ commas(data.item.charge) }}
                  </template>
                  <template #cell(feecharge)="data">
                    {{ commas(data.item.feecharge) }}
                  </template> -->
                  <template #cell(services)="data">
                    <div class="btn-group">
                      <router-link :to="{ path: '/ledger',  query: { id: data.item.id }}" type="button" class="btn-sm btn btn-dark"> ledger</router-link>
                    </div>
                  </template>

                  <template #cell(balance)="data">
                    <span v-if="data.item.balance>0">
                    {{ commas(data.item.balance) }} <br>
                      <b-button @click="pay(data.item.id,data.item.patient.patient_id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone,data.item.balance,data.item.patient.patient_id,data.item.visit_id, data.item.cutoff)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-cash"></i> pay</b-button>
                    </span>
                   
                    <span v-else class="text-primary">
                        <i class="fas fa-check"></i> Paid 

                        <div class="row" v-if="userData.permissions['edit_finance']==1">

                        <b-button @click="refunds(data.item.id,data.item.patient.patient_id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone,data.item.paid,data.item.patient.patient_id,data.item.visit_id, data.item.cutoff)" type="button" class="btn-sm btn" variant="danger" v-b-modal.edit> <i class="mdi mdi-undo"></i> Refund</b-button>
                        </div>

                    </span>
  
  
                  </template>
              
                  </b-table>
                  <div class="mt-3">
                    <div class="mt-3">
                <span class="total-label">Total Service:</span>
                <span class="total-value">{{commas (totalservices) }}</span>
  
                <span class="total-label">Total Prescriptions:</span>
                <span class="total-value">{{commas (totalPrescriptions) }}</span>
  
                <span class="total-label">Total Consumables:</span>
                <span class="total-value">{{commas (totalConsumables) }}</span>
  
                <span class="total-label">Total Paid:</span>
                <span class="total-value">{{commas (totalPaid) }}</span>
  
                <span class="total-label">Total Balance:</span>
                <span class="total-value">{{commas (totalBalance) }} </span>
  
                <span class="total-label">Total Discounts:</span>
                <span class="total-value">{{commas (totalDiscounts) }} </span>
              </div>
              </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to View Patients Payments</span></center>
            </div>
          </div>
        </div>
      </div>
      <b-modal id="view-pay" centered title="Patient Payment" title-class="font-14" hide-footer>
        <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
         Gender : <span class="text-primary">{{ gender }}</span>
         Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
         <form @submit.prevent="addPayment">
              <input v-model="patient_id" type="hidden"/>
              <input v-model="visit_id" type="hidden"/>
              <div class="form-group mb-2">
              <label>Total Amount</label>
              <input  v-model="amount_compute"  readonly   type="number" class="form-control"/>
             </div>
             <div class="form-group mb-2">
              <label>Discount</label>
              <input v-model="amount_discount"  @input="FilterPrice" type="number" class="form-control"/>
              </div>
                <div class="form-group mb-2">
              <label>Amount Paid</label>
              <input v-model="amount_paid" @input="FilterPrice" type="number"  class="form-control" />
              </div>
              
            
              <div class="form-group mb-2">
                <label>Payment Type</label>
                <b-form-select class="form-control" @change="CheckPayType" v-model="payment_type">
                  <option value="1">Other payments</option>
                  <option value="3">Personal Account</option>
                </b-form-select>
              </div>
              <div class="form-group mb-2" v-show="showaccountbalance">
                <label>Account Balance</label>
                <input v-model="account_balance" readonly type="number" class="form-control" />
              </div>
              <div v-show="showpaymethod" class="form-group mb-2">
              <label>Payment Method</label>
              <multiselect v-model="payment_method" :options="paymentoptions" label="name"></multiselect>
              </div>
              <div class="form-group mb-2">
              <label>Pay Date</label>
              <input v-model="paydate" type="date" class="form-control"/>
              </div>
              <br><span class="text-danger">{{ error }}</span>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-pay')" >Close</b-button>
                  <b-button type="submit" :disabled="balancebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
      <!-- refund payment -->
      <b-modal id="view-refund" centered title="Refund Payment" title-class="font-14" hide-footer>
        <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
         Gender : <span class="text-primary">{{ gender }}</span>
         Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
         <form @submit.prevent="addPaymentRefund">
              <input v-model="patient_id" type="hidden"/>
              <input v-model="visit_id" type="hidden"/>
              <div class="form-group mb-2">

              <label>Amount Paid</label>

              <input  v-model="amount_compute"  readonly   type="number" class="form-control"/>
            </div>
           
                <div class="form-group mb-2">

              <label>Acutal Amount Paid</label>

              <input v-model="amount_paid" @input="FilterPrice" type="number"  class="form-control" />
              </div>
              
            
              <div class="form-group mb-2">
                <label>Payment Type</label>
                <b-form-select class="form-control" @change="CheckPayType" v-model="payment_type">
                  <option value="1">Other payments</option>
                  <option value="3">Personal Account</option>
                </b-form-select>
              </div>
              <div class="form-group mb-2" v-show="showaccountbalance">
                <label>Account Balance</label>
                <input v-model="account_balance" readonly type="number" class="form-control" />
              </div>
              <div v-show="showpaymethod" class="form-group mb-2">
              <label>Payment Method</label>
              <multiselect v-model="payment_method" :options="paymentoptions" label="name"></multiselect>
              </div>
              <div class="form-group mb-2">
              <label>Refund Date</label>
              <input v-model="paydate" type="date" class="form-control"/>
              </div>
              <br><span class="text-danger">{{ error }}</span>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-refund')" >Close</b-button>
                  <b-button type="submit" :disabled="balancebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
    </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import Multiselect from "vue-multiselect";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { paymentoptionComputed, paymentoptionMethods, patientpaymentMethods, patientpaymentComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Patient Payments",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,Multiselect
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Patient Payments",
        items: [ {text: "Dashboard",to: "/",}, {text: "Patient Payments",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'total_amount', label: 'Service Amount', visible: true },
            { key: 'prescription', label: 'Prescription', visible: true },
            { key: 'consumables', label: 'Consumables', visible: true },
            { key: 'paid', label: 'Amount Paid', visible: true },
            { key: 'discount',label: 'Discount', visible:true},
            { key: 'balance', label: 'Balance', visible: true },
            { key: 'visit_date', label: 'Visit Date', visible: true },
            { key: 'services', label: 'Details', visible: true },
          ],
        services:[],
        prescriptions:[],
        visitID:'',
        id:'',
        telephone:'',
        name:'',
        gender:'',
        patient_id:'',
        visit_id:'',
        payment_method:'',
        payment_type:"1",
        amount_paid:'',

        amount_discount:0,

        amount_charged:'',
        amount_compute:'',
        paydate:new Date().toLocaleDateString('fr-CA'),
        showaccountbalance:false,
        account_balance:0,
        balancebtn:true,
        isAmountPaidManuallyEdited: true,
        showpaymethod:true,
        error:'',
        refund:'',
        datefrom: new Date().toLocaleDateString('fr-CA'),
        dateto: new Date().toLocaleDateString('fr-CA'),
      };
    }, 
    computed: {
      ...patientpaymentComputed,
      ...paymentoptionComputed,
      List() { return this.patientpayments.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.patientpayments.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.patientpayments.length>0) { a=false;} else { a=true;} return a },
      totalPrescriptions() { return this.Items.reduce((total, item) => total + item.prescriptions, 0); },
      totalConsumables() { return this.Items.reduce((total, item) => total + item.consumables, 0); },
      totalPaid() { return this.Items.reduce((total, item) => total + item.paid, 0); },
      totalservices(){ var total = 0; this.patientpayments.forEach((item)=>{ var item_total = item.total_amount; total = Number(total)+Number(item_total);}); return total },
      totalAmount() { return this.Items.reduce((total, item) => total + item.total_amount, 0); },
      totalBalance() { return this.Items.reduce((total, item) => {return total + (item.balance > 0 ? item.balance : 0); }, 0);},
      totalDiscounts() { return this.Items.reduce((total, item) => {return total + (item.discount > 0 ? item.discount : 0); }, 0);},
    },
    mounted() {
      this.fetchPatientPayments();
      this.fetchPaymentoptions();
      this.TotalRows = this.patientpayments.length;
      this.isBusy=false;
      this.payment_method = this.paymentoptions.find(option => option.set_default == 1);
    },
    methods: {
      ...patientpaymentMethods,
      ...paymentoptionMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      FilterData() {  this.filterPatientPayments({datefrom:this.datefrom,dateto:this.dateto});  },
      commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      async CheckPayType(){
        if (this.payment_type=='3') {
          let url = `/checkpaytype/${this.patient_id}`;
          await axios.get(url).then((response) => {
            this.account_balance = response.data.balance;
            this.showaccountbalance=true;
            this.showpaymethod=false;
            this.FilterPrice();
          });
        } else {
              this.balancebtn=true;
              this.showaccountbalance=false;
              this.showpaymethod=true;
              this.error='';
        }
      },
      
  async FilterPrice() {
    if (this.payment_type === '3') {
      // If payment type is 'Personal Account'
      this.showpaymethod = false;
      this.balance = this.account_balance - this.amount_paid - this.amount_discount;
      
      if (this.balance < 0) {
        this.balancebtn = false;
        this.error = "Insufficient Balance";
      } else {
        this.error = '';
        this.balancebtn = true;
      }
    } else {
      // If payment type is not 'Personal Account'
      // Calculate the amount to be paid before discount
      const amountToBePaid = this.amount_compute;
      
      // Check if the discount amount exceeds the amount charged
      if (this.amount_discount > amountToBePaid) {
        this.amount_discount = amountToBePaid; // Set discount to maximum allowed
      }
      
      // Calculate the amount to be paid after applying the discount
      const discountedAmount = amountToBePaid - this.amount_discount;
      
      // Check if the amount paid exceeds the discounted amount
      if (this.amount_paid > discountedAmount) {
        this.amount_paid = discountedAmount; // Set amount paid to maximum allowed
      }
      
      // Update balance based on the current amount_paid
      this.balance = discountedAmount - this.amount_paid;
  
      // Show error message if balance is negative
      if (this.balance < 0) {
        this.balancebtn = false;
        this.error = "Insufficient Balance";
      } else {
        this.error = '';
        this.balancebtn = true;
      }
    }
  },
  
  
      pay(visit,id,name,gender,telephone,balance,patient_id,visit_id,cutoff,feecharge){
        this.visitID=visit;
        this.id=id;
        this.name=name;
        this.gender=gender;
        this.telephone=telephone;
        this.amount_paid=balance;
        this.amount_compute = this.amount_paid;
        this.amount_discount = cutoff ?? 0;
        this.amount_charged=feecharge;
        this.patient_id=patient_id;
        this.visit_id=visit_id;
        this.$bvModal.show('view-pay')
      },
  
      refunds(visit,id,name,gender,telephone,paid,patient_id,visit_id,cutoff,feecharge){
        this.visitID=visit;
        this.id=id;
        this.name=name;
        this.gender=gender;
        this.telephone=telephone;
        this.amount_paid=paid;
        this.amount_compute = this.amount_paid;  
        this.amount_discount = cutoff ?? 0;
        this.amount_charged=feecharge;
        this.patient_id=patient_id;
        this.visit_id=visit_id;
        this.$bvModal.show('view-refund')
      },
      async addPayment() {
        this.balancebtn=false;
        this.error="Saving Patient Payment";
        let formData = new FormData();
        formData.append("visitID", this.visitID);
        formData.append("patient", this.patient_id);
        formData.append("visit_id", this.visit_id);
        formData.append("payment_option", this.payment_method.id);
        formData.append("payment_type", this.payment_type);
        formData.append("amount_discount", this.amount_discount ?? 0);
        formData.append("amount_paid", this.amount_paid);
        // formData.append("amount_charged",this.amount_charged);
        formData.append("pay_date", this.paydate);
        let url = "/addpayment"; 
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPatientPayments();
            this.$bvModal.hide('view-pay');
            this.balancebtn=true;
            this.error="";
            this.patient="";
            this.visit_id="";
            this.account_balance="";
            this.amount_discount=0;
            // this.amount_charged="";
            this.payment_type="1";
            this.amount_paid="";
            this.$toast.success("Patient Payment Added");
        }
        });
      },
  
      async addPaymentRefund() {
        this.balancebtn=false;
        this.error="Saving Patient Refund";
        let formData = new FormData();
        formData.append("visitID", this.visitID);
        formData.append("patient", this.patient_id);
        formData.append("visit_id", this.visit_id);
        formData.append("payment_option", this.payment_method.id);
        formData.append("payment_type", this.payment_type);
        formData.append("amount_paid", this.amount_paid);
        formData.append("pay_date", this.paydate);
        let url = "/refundpayment"; 
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPatientPayments();
            this.$bvModal.hide('view-refund');
            this.balancebtn=true;
            this.error="";
            this.patient="";
            this.visit_id="";
            this.account_balance="";
            this.payment_type="1";
            this.amount_paid="";
            this.$toast.success("Patient Refund Added");
        }
        });
      },
      async refundPayments(patient_id, amount_paid, visit_id) {
    this.balancebtn = false;
    this.error = "Processing refund...";
  
    // Create form data
    let formData = new FormData();
    formData.append("patient_id", patient_id);
    formData.append("amount_paid", amount_paid);
    formData.append("visit_id", visit_id);
  
    let url = "/refundpayment"; // Define the endpoint for refunding payment
  
    // Make the request and handle the response without catch block
    let response = await axios.post(url, formData);
  
    // Check the response status and handle success or failure
    if (response && response.status === 200) {
      this.fetchPatientPayments(); // Refresh payment data
      this.balancebtn = true;
      this.error = "";
      this.$toast.success("Payment refunded successfully.");
    } else {
      this.balancebtn = true;
      this.error = "Failed to refund payment.";
      this.$toast.error("Failed to refund payment. Please try again.");
    }
  },


  refundPayment(patient_id, total_paid, visit_id) {
  this.patient_id = patient_id;
  this.total_paid = total_paid;
  this.visit_id = visit_id;
  this.refund_amount = 0; // Reset refund amount
  this.refund_date = new Date().toLocaleDateString('fr-CA'); // Reset refund date
  this.refund_payment_type = "1"; // Reset refund payment type
  this.$bvModal.show('refund-modal'); // Show the refund modal
},

// Method to process refund
async processRefund() {
  const response = await axios.post('/refund-payment', {
    patient_id: this.patient_id,
    visit_id: this.visit_id,
    refund_amount: this.refund_amount,
    refund_payment_type: this.refund_payment_type,
    refund_date: this.refund_date
  });


  if (response && response.data && response.data.success) {
    this.$bvToast.toast('Refund processed successfully!', { variant: 'success', solid: true });
    this.$bvModal.hide('refund-modal');
    this.fetchPatientPayments(); // Refresh data after refund
  } else {
    this.$bvToast.toast('Failed to process refund!', { variant: 'danger', solid: true });
  }
}
    }
  
  };
  </script>
  <style scoped>
  .total-label {
    margin-right: 10px; /* Adjust the spacing as needed */
  }
  
  .total-value {
    font-weight: bold;
    margin-right: 20px; /* Adjust the spacing as needed */
  }
  </style>
